import { AttendanceCode } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';
import { WithJustificationChangeModal } from '@schooly/components/justifications';
import { FC, ReactNode, useMemo } from 'react';

import { WithDataGridHover } from '../../../../context/table/dataGridHover/WithDataGridHover';
import { allowRenderStudents } from '../../../../helpers/renderRoutesByPermissions';
import { getCodesById } from '../../attendance-utils';
import { AttendanceSidebar } from '../AttendanceSidebar/AttendanceSidebar';
import { AttendanceCellContextProvider } from '../common/AttendanceCells';
import { useAttendanceSidebar } from './useAttendanceSidebar';

type AttendanceGridShellProps = {
  codes: AttendanceCode[];
  groupId?: string;
  children: ReactNode;
};

export const AttendanceGridShell: FC<AttendanceGridShellProps> = ({ codes, groupId, children }) => {
  const { selected, openForCell, close } = useAttendanceSidebar();
  const { permissions } = useAuth();
  const canViewStudents = allowRenderStudents(permissions);

  const codesById = useMemo(() => getCodesById(codes), [codes]);

  const cellContextValue = useMemo(
    () => ({ codesById, onCellClick: openForCell, canViewStudents }),
    [canViewStudents, codesById, openForCell],
  );

  return (
    <AttendanceCellContextProvider value={cellContextValue}>
      <WithDataGridHover>{children}</WithDataGridHover>

      {selected && (
        <WithJustificationChangeModal>
          <AttendanceSidebar
            data={selected.data}
            student={selected.student}
            codesById={codesById}
            groupId={groupId}
            onClose={close}
          />
        </WithJustificationChangeModal>
      )}
    </AttendanceCellContextProvider>
  );
};
